import { Injectable } from '@angular/core';
import { ApiService } from '../../../core/services/api/api.service';
import { ForgetPasswordRequestBodyI } from './interfaces/forget-password-request-body.interface';
import { SetNewPasswordRequestBodyI } from '../first-time-login/interfaces/set-new-password-request-body.interface';
import { CheckForgetPasswordRequestBodyI } from './interfaces/check-forget-password-request-body.interface';
import { ForgetPasswordI } from './interfaces/forget-password.interface';

@Injectable({
  providedIn: 'root',
})
export class ForgetPasswordApiService {
  constructor(private readonly apiService: ApiService) {}

  requestOtp(forgetPasswordRequestBody: ForgetPasswordRequestBodyI) {
    return this.apiService.post<string>(
      'otps/forget-password',
      forgetPasswordRequestBody
    );
  }

  setNewPassword(setNewPasswordRequestBody: SetNewPasswordRequestBodyI) {
    return this.apiService.post<string>(
      `auth/forget-password`,
      setNewPasswordRequestBody
    );
  }
  checkForgetPassword(
    checkForgetPasswordRequestBody: CheckForgetPasswordRequestBodyI
  ) {
    return this.apiService.post<ForgetPasswordI>(
      'otps/check-forget-password',
      checkForgetPasswordRequestBody
    );
  }
}
